module.exports = __webpack_public_path__ + "static/media/Bibarel_gaussian2.3f641d96.png";